export const FEATURE_NAME = '@vshosting/cdn/features/login';
